import script from "./_ItemEditReviewSingleParentPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./_ItemEditReviewSingleParentPreview.vue?vue&type=script&setup=true&lang=js"

import "./_ItemEditReviewSingleParentPreview.vue?vue&type=style&index=0&id=9ad23222&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ad23222"]])

export default __exports__